import React,{useState} from 'react';
import EmployAside from '../../aside';
import DevisIndex from './devis';

const  Devis = () => {
  const [isOpenSidebar,setIsOpenSidebar] = useState(false);
  return (    

    <div className='main-page-wrapper'>
      <EmployAside isOpenSidebar={isOpenSidebar} setIsOpenSidebar={setIsOpenSidebar}/>

      <DevisIndex setIsOpenSidebar={setIsOpenSidebar}/>
      
    </div>    
  );
};

export default Devis;